import useCardMediaQuery from "../../hooks/useCardMediaQuery"

import Grid from "@mui/material/Grid"
import Lazyload from "react-lazyload"
import InfiniteScroll from "react-infinite-scroll-component"

import { CARD_TYPES } from "../../utils/constants"

import styles from "./styles.module.scss"
import DefaultCard from "../cards/DefaultCard"
import MediaCardHorizontal from "../cards/MediaCardHorizontal"
import MediaCardSquare from "../cards/MediaCardSquare"
import LoadingCardSkeleton from "../LoadingCardSkeleton"
import CardSkeleton from "../ui/CardSkeleton"

const InfiniteCardList = ({
  data,
  cardType,
  fetchMoreData,
  allLoaded,
  cardGridSizeOverride,
  cardProps
}) => {
  const [, cardGridSize] = useCardMediaQuery(cardType)
  const gridSize = cardGridSizeOverride || cardGridSize

  let Card
  if (cardType === CARD_TYPES.HORIZONTAL) {
    Card = MediaCardHorizontal
  } else if (cardType === CARD_TYPES.SQUARE) {
    Card = MediaCardSquare
  } else {
    Card = DefaultCard
  }

  return (
    <InfiniteScroll
      className={styles.infiniteScrollContainer}
      dataLength={data.length}
      next={fetchMoreData}
      hasMore={!allLoaded}
      scrollThreshold="600px"
      loader={
        <>
          <div className="space-top-28"></div>
          <LoadingCardSkeleton type={cardType} />
        </>
      }
    >
      {data.map((dataItem) => (
        <Grid
          className={styles.infiniteScrollItem}
          item
          xs={gridSize.xs}
          xsm={gridSize.xsm}
          sm={gridSize.sm}
          md={gridSize.md}
          lg={gridSize.lg}
          key={dataItem.id}
        >
          <Lazyload
            key={cardType}
            height={200}
            offset={50}
            placeholder={<CardSkeleton type={cardType} />}
          >
            <Card data={dataItem} {...cardProps} />
          </Lazyload>
        </Grid>
      ))}
    </InfiniteScroll>
  )
}
export default InfiniteCardList
